<script>import { getContext, onDestroy } from "svelte";
import {
  mapContextKey
} from "../../components/map/context.js";
import { WindVectorFactory } from "./wind-vector-factory.js";
export let windVector;
export let wvf;
export let wsZeroThreshold = 4e-3;
const position = { x: wvf.cellSize() / 2, y: wvf.cellSize() / 2 };
const getContent = () => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 ${-wvf.cellSize()} ${wvf.cellSize()} ${wvf.cellSize()}" style="margin-left:${-wvf.cellSize() / 2}px; margin-top:${-wvf.cellSize() / 2}px; width:${wvf.cellSize()}px; height:${wvf.cellSize()}px; overflow:visible;"><g style="--fontsize:${wvf.fontSize()}px;" role="tooltip"><path d="M 0 0Z" fill="transparent"/><circle cx="${position.x}"
    cy="${-position.y}"
    r="${wvf.radiusMax()}"
    stroke="${"gray"}"
    stroke-width="${wvf.stroke()}"
    fill="${"white"}"
  /><text
      text-anchor="middle"
      x="${position.x}"
      y="${-position.y}"
      dy="${wvf.labelDY()}"
      fill="${"gray"}">${"?"}</text
    ></g></svg>`;
  const doc = new DOMParser().parseFromString(svg, "image/svg+xml");
  return doc.documentElement;
};
const { map, mapImplementationWrapper } = getContext(mapContextKey);
let marker;
$:
  if (!marker && windVector)
    marker = mapImplementationWrapper.createMarker(
      windVector.latLng,
      getContent()
    );
$:
  if ($map && marker && windVector)
    marker.addTo($map);
$:
  if ($map && marker && !windVector)
    marker.remove();
$:
  if (marker && windVector)
    marker.setLatLng(windVector.latLng);
$: {
  if (marker && windVector && windVector.u !== void 0 && windVector.v !== void 0) {
    const windVectorNode = marker.getContent();
    if (windVectorNode) {
      const ws = Math.sqrt(
        windVector.u * windVector.u + windVector.v * windVector.v
      );
      const angle = Math.atan2(windVector.v, windVector.u);
      wvf.displayWindSpeed(true);
      const label = (ws > 0 ? ws : 0).toFixed(
        ws > 100 ? 0 : ws >= 1 ? 1 : 2
      );
      const colorHex = wvf.color(ws);
      const innerColorHex = wvf.innerColor(ws, true);
      const d = ws > wsZeroThreshold ? wvf.arrowPath(ws, angle, position) : "";
      const pathFill = ws > wsZeroThreshold ? wvf.color(ws) : "transparent";
      const path = windVectorNode.querySelector("path");
      if (path) {
        path.setAttribute("d", d);
        path.setAttribute("fill", pathFill);
      }
      const circle = windVectorNode.querySelector("circle");
      if (circle) {
        circle.setAttribute("stroke", colorHex);
        circle.setAttribute("fill", innerColorHex);
      }
      const text = windVectorNode.querySelector("text");
      if (text) {
        text.setAttribute("fill", colorHex);
        text.textContent = label;
      }
    }
  }
}
onDestroy(() => {
  marker?.remove();
  marker = void 0;
});
</script>
